module.exports = __webpack_public_path__ + "img/download.3f6b0e31.webp";